import axios from 'axios'

export default class ConsultarUnimed {
  constructor (tokenBearer, url) {
    this.url = url
    this.tokenBearer = tokenBearer
  }

  getConsultarUnimed (args) {
    let url = `${this.url}/api/unimed/consulta?${args}`

    return new Promise(async (resolve, reject) => {
      let optionsConsultarUnimed = {
        method: 'get',
        url,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseConsultarUnimed = await axios(optionsConsultarUnimed)
        resolve(responseConsultarUnimed)
      } catch (err) {
        reject(err)
      }
    })
  }

  exportar (args) {
    let url = `${this.url}/api/unimed/exportar?${args}`
    return new Promise(async (resolve, reject) => {
      let optionsUnimed = {
        method: 'get',
        url: url,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(optionsUnimed)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
